import { CircleHelp } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const OPEN_HELP_EVENT = 'erp:open-help';

export interface InlineHelpProps {
  readonly articleId: string;
  readonly anchor?: string | undefined;
  readonly label: string;
}

export function InlineHelp({
  articleId,
  anchor = 'overview',
  label,
}: InlineHelpProps): JSX.Element {
  return (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      className="h-9 w-9 shrink-0"
      aria-label={label}
      onClick={() => {
        const url = new URL(window.location.href);
        url.searchParams.set('help', articleId);
        url.searchParams.set('helpAnchor', anchor);
        window.history.replaceState(
          window.history.state,
          '',
          `${url.pathname}${url.search}${url.hash}`,
        );
        window.dispatchEvent(new CustomEvent(OPEN_HELP_EVENT, { detail: { articleId, anchor } }));
      }}
    >
      <CircleHelp className="h-4 w-4" aria-hidden="true" />
    </Button>
  );
}
